 
// let urlGift = "https://kanyoga.com/products/shower-cap-palm-leafs-print-white-green";
// let pageUrl = window.location.href;

// if (pageUrl == urlGift) {
//     alert("232424");
//     pageUrl ="https://kanyoga.com/collections/all";
// }


if (window.location.href.includes("shower-cap-palm-leafs-print-white-green")) {
    window.location.replace("https://kanyoga.com/collections/all"); // put your desired URL here
}


 document.addEventListener("DOMContentLoaded", function () {
  const minTotal = 1000; // Minimum cart total for free gift
  const messageId = "free-gift-message";

  // Function to fetch cart and check total
  function checkCartTotal() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let cartTotal = cart.total_price / 100; // Shopify gives in paise, convert to ₹
        
        // Remove old message if exists
        let oldMsg = document.getElementById(messageId);
        if (oldMsg) oldMsg.remove();

        // If below threshold → show message
        if (cartTotal < minTotal) {
          let remaining = minTotal - cartTotal; // calculate remaining amount
          let msg = document.createElement("p");
          msg.id = messageId;
          msg.style.color = "white";
          msg.style.fontWeight = "bold";
          msg.style.marginTop = "10px";
          msg.innerText = "Add items worth ₹" + remaining.toFixed(2) + " more to receive a free gift 🎁 + free delivery!";
          
          // Append message inside cart container
          let cartForm = document.querySelector("form[action='/cart']") || document.querySelector("#CartContainer");
          if (cartForm) {
            cartForm.appendChild(msg);
          }
        }
      });
  }

  // Run once on page load
  checkCartTotal();

  // Re-check when quantity is updated
  document.addEventListener("change", function (e) {
    if (e.target.closest(".cart__quantity") || e.target.closest("input[name='quantity']")) {
      setTimeout(checkCartTotal, 500); // give Shopify time to update
    }
  });
});

 
